import { Component, forwardRef, HostListener, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'aims-new-grid-file-upload',
  templateUrl: './new-grid-file-upload.component.html',
  styleUrls: ['./new-grid-file-upload.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NewGridFileUploadComponent),
      multi: true,
    },
  ],
})
export class NewGridFileUploadComponent implements OnInit, ControlValueAccessor  {

  @Input() fileName: string = null;
  @Input() allowedFileType: string = '.bmp,.pdf,.csv'
  @Input() maxFileSize: number = 30194304
  isDisabled = false;
  showTooBig: boolean = false

  fileGridCmd: FileGridCmd = new FileGridCmd();

  dragAreaClass: string
  dragAreaLabel: string = 'Drag'

  constructor( ) { }

  reset() {
    this.fileGridCmd = new FileGridCmd()
    this.fileGridCmd.action = FileGridCmds.noop;
    this.fileGridCmd.files = null;
  }

  ngOnInit(): void {
    this.reset();
  }

  // ControlValueAccessor implementation

  // This method is called by the forms API to write to the view when programmatic changes from model to view are requested.
  writeValue(value: any) {
    if (value !== undefined && value != null) {
      // this.fileGridCmd = value;
    }
  }

  // defaults, so your app doesn't crash when one isn't (yet) registered
  onChange = (_: any) => {}
  onTouched = () => {}

  // This method is called by the forms API on initialization to update the form model when values propagate from the view to the model.
  registerOnChange(fn: any) {
    this.onChange = fn
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn
  }

   setDisabledState(isDisabled: boolean) {
    this.isDisabled = isDisabled;
  }
  // End ControlValueAccessor implementation

 // Host Listener methods
  @HostListener('dragover', ['$event']) onDragOver(event: any) {
    this.dragAreaClass = 'droparea'
    this.dragAreaLabel = 'Drop'
    event.preventDefault()
  }
  @HostListener('dragenter', ['$event']) onDragEnter(event: any) {
    this.dragAreaClass = 'droparea'
    this.dragAreaLabel = 'Drop'
    event.preventDefault()
  }
  @HostListener('dragend', ['$event']) onDragEnd(event: any) {
    this.dragAreaClass = 'dragarea'
    this.dragAreaLabel = 'Drag'
    event.preventDefault()
  }
  @HostListener('dragleave', ['$event']) onDragLeave(event: any) {
    this.dragAreaClass = 'dragarea'
    this.dragAreaLabel = 'Drag'
    event.preventDefault()
  }
  @HostListener('drop', ['$event']) onDrop(event: any) {
    this.dragAreaClass = 'dragarea'
    this.dragAreaLabel = 'Drag'
    event.preventDefault()
    event.stopPropagation()
    if (event.dataTransfer.files) {
      let files: FileList = event.dataTransfer.files
      this.onFileSelected(files)
    }
  }

  public onFileSelected(files): void {
    this.fileGridCmd = new FileGridCmd();
    this.fileGridCmd.files = files;
    this.fileGridCmd.action = FileGridCmds.add;
    this.handleFileSelected(this.fileGridCmd);
  }

  fileDelete() {
    this.fileGridCmd = new FileGridCmd();
    this.fileGridCmd.action = FileGridCmds.delete;
    this.fileGridCmd.files = null;

    this.fileName = null;

    this.onTouched();
    this.onChange(this.fileGridCmd);
  }

  private handleFileSelected(fileGridCmd: FileGridCmd) {
    if (this.fileGridCmd.files.length == 0) {
      console.log('No file selected!')
      return
    }

    let file: File = this.fileGridCmd.files[0]
    if (file.size > this.maxFileSize) {
      this.fileTooBig(file.name)
      return
    }
    this.fileName = file.name;

    this.onTouched();
    this.onChange(this.fileGridCmd);
  }

  private fileTooBig(fileName: string): void {
    console.log(`file ${fileName} too large!`)
    this.showTooBig = true
    setTimeout(() => {
      this.showTooBig = false
    }, 3000)
  }

}

export class FileGridCmd {
  action: FileGridCmds;
  files: FileList;
}

export enum FileGridCmds {
  noop,
  add,
  delete,
}
